import { Injectable } from '@angular/core';

/*Models */
import { Device, StatsTrack } from '@models';

/*Service */
import { CachedDataService } from './data/cached-data.service';

/*Plugins */
import * as moment from 'moment';

/*Models */
import { ObservableObject } from '@models';

@Injectable()
export class AppService {

  constructor(private cachedDataService: CachedDataService) {

  }
  sortedArray(array, field, direction?) {
    let dir = 1;
    if (direction) {
      dir = direction;
    }
    return array.sort((a, b) => {
      a[field] = parseInt(a[field]);
      b[field] = parseInt(b[field]);
      
      if (a[field] < b[field]) { return -1 * dir; } else if (a[field] > b[field]) { return 1 * dir; } else { return 0; }
    });
  }



  parseDateReportsStat(response: Array<StatsTrack>) {
    const userDateTimeOffset = this.userTimezoneOffset();

    response.map(item => {
      item.fromUnix = moment(item.from).startOf('day').unix() + (userDateTimeOffset * 60 * 60);
      item.toUnix = moment(item.to).endOf('day').unix() + (userDateTimeOffset * 60 * 60);
      item.fromFormat = moment(item.from).format('DD.MM.YYYY');
      item.toFormat = moment(item.to).format('DD.MM.YYYY');
      item.averageSpeed = parseFloat(parseFloat(item.averageSpeed).toFixed(2)).toString();
      item.maxSpeed = parseFloat(parseFloat(item.maxSpeed).toFixed(2)).toString();
      item.travelTimeHours = parseFloat((this.secondsToTime(item.travelTime).h + this.secondsToTime(item.travelTime).m / 60).toFixed(2));
      item.travelTimeFormat = {
        hours: this.secondsToTime(item.travelTime).h,
        minutes: this.secondsToTime(item.travelTime).m
      };
    });
    response = this.sortedArray(response, 'fromUnix', -1);
  }

  secondsToTime(secs) {
    const hours = Math.floor(secs / (60 * 60));

    const divisor_for_minutes = secs % (60 * 60);
    const minutes = Math.floor(divisor_for_minutes / 60);

    const divisor_for_seconds = divisor_for_minutes % 60;
    const seconds = Math.ceil(divisor_for_seconds);

    const obj = {
      'h': hours,
      'm': minutes,
      's': seconds
    };
    return obj;
  }

  userTimezoneOffset(): number {
    let userTimezoneOffset;
    if (this.cachedDataService.ifWatchAnotherUser) {
      userTimezoneOffset = this.cachedDataService.getCurrentObject().user.dateTimeOffset;
    } else {
      userTimezoneOffset = -new Date().getTimezoneOffset() / 60;
    }
    return userTimezoneOffset;
  }

  filterObjects(observableObjects:Array<ObservableObject>):Array<ObservableObject>{
    // let newObjectList:Array<ObservableObject> = [];
    // let isHidden = false;
    observableObjects = observableObjects.filter(object => object.devices && object.devices.length);

    observableObjects.map(object=>{
      if(object.devices){
        object.devices.map(device=>{
         device = this.filterHiddepPhoneDevice(device);
        })
      }
      // if(!isHidden){
      //   newObjectList.push(object);
      // }
    })
    return observableObjects;
  }
  filterHiddepPhoneDevice(device: Device){
    if(device.phones){
      if(device.phones.filter(phone=>phone.isHidden).length){
        device["isHiddenPhone"] = true;
      }
    }
    return device;
  }
 
}



// WEBPACK FOOTER //
// ./src/app/shared/services/app.service.ts